<main
  class="changeBackground animated-bg h-full w-full flex justify-center overflow-hidden"
>
  <div class="main-container">
    <app-header class="h-[50px]"></app-header>
    <div class="body-container">
      <router-outlet></router-outlet>
    </div>
    <app-footer class="h-[60px]"></app-footer>
  </div>
</main>
